import AmexGDAOffersBenefits from './AmexGDAOffersBenefits';

export default AmexGDAOffersBenefits;
